import React, { useRef } from "react";
import cx from "classnames";
import styles from "./CategoryList.module.css";

import rightArroSvg from "../../../images/VideospageImages/RightArro.svg";
import leftArroSvg from "../../../images/VideospageImages/LeftArro.svg";
import Image from "next/image";
const CategoryList = ({ catList, activeCat, setActiveCat, catTitle }) => {
    const tagListRef = useRef();
    const slideright = () => {
        tagListRef.current.scrollBy({
            top: 0,
            left: +100,
            behavior: "smooth",
        });
    };
    const slideleft = () => {
        tagListRef.current.scrollBy({
            top: 0,
            left: -100,
            behavior: "smooth",
        });
    };
    return(
        <div
            id="newsCategories"
            className={cx(
                styles.catListContainer,
                "w-100",
                "d-flex",
                "align-items-center",
                "justify-content-between"
            )}
        >
            <button
                onClick={slideright}
                className={cx(
                    styles.nextCategoryBtnStyles,
                    // "d-xxl-none",
                    "d-flex",
                    "align-items-center",
                    "justify-content-center",
                    "ps-0"
                )}
            >
                <Image src={rightArroSvg} alt="Right Arrow" />
            </button>
            <div
                ref={tagListRef}
                className={cx(
                    styles.tagListContainerInner,
                    "d-flex",
                    "w-100",
                    "align-items-center",
                    "justify-content-start"
                )}
            >
                <button
                    onClick={() => {
                        setActiveCat("");
                    }}
                    className={cx(
                        styles.categorySelectBtn,
                        activeCat?.length === 0 && styles.categorySelectBtnActive
                    )}
                >
                    {/*همه ویدیوها*/}
                    {'همه' + ' ' + catTitle}
                </button>
                {catList?.length > 0 &&
                    catList?.map((cat, indx) => (
                        <button
                            // onClick={() => {
                            //   activeCat.includes(String(cat.id))
                            //     ? setActiveCat(activeCat.filter((v) => v !== String(cat.id)))
                            //     : setActiveCat([...activeCat, String(cat.id)]);
                            // }}
                            onClick={() => {
                                String(activeCat) === String(cat.id)
                                    ? setActiveCat("")
                                    : setActiveCat(String(cat.id));
                            }}
                            key={indx}
                            className={cx(
                                styles.categorySelectBtn,
                                String(activeCat) === String(cat.id) &&
                                styles.categorySelectBtnActive
                            )}
                        >
                            {cat.title}
                        </button>
                    ))}
            </div>
            <button
                onClick={slideleft}
                className={cx(
                    styles.precCategoryBtnStyles,
                    // "d-xxl-none",
                    "d-flex",
                    "align-items-center",
                    "justify-content-center",
                    "pe-0"
                )}
            >
                <Image src={leftArroSvg} alt="Left Arrow" />
            </button>
        </div>
    )
}

export default CategoryList